const fields = [
  {
    type: 'bsx-label',
    label: '姓名',
    model: 'name',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '員工編號',
    model: 'eid',
    placeholder: '員工編號',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '身分證字號',
    model: 'twid',
    placeholder: '身分證字號',
    required: true,
    disabled: (model) => model.id,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '工作院區',
    model: 'clinic',
    placeholder: '工作院區',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '部門',
    model: 'dept',
    placeholder: '部門',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    textOn: '在職',
    textOff: '離職',
    valueOn: 'NORMAL',
    valueOff: 'RESIGN',
    visible: (model) => model.id,
  },
];

export default fields;
